import dev.shanty.kotwire.stimulus.Controller
import dev.shanty.kotwire.stimulus.StimulusController
import kotlinx.browser.window
import org.w3c.dom.HTMLInputElement

@JsExport
@StimulusController(
    targets = [],
    values = PackingWhoController.Values::class,
)
class PackingWhoController(context: dynamic) : Controller(context) {

    object Values {
        val storageKey: String = ""
    }

    private val storageKey by storageKeyValue()

    override fun connect() {
        val saved = window.localStorage.getItem(storageKey) ?: return
        val selectedNames = saved.split(",").filter { it.isNotEmpty() }.toSet()
        val checkboxes = element.querySelectorAll("input[type=checkbox]")
        for (i in 0 until checkboxes.length) {
            val cb = checkboxes.item(i) as? HTMLInputElement ?: continue
            cb.checked = cb.name in selectedNames
        }
    }

    @JsName("save")
    fun save() {
        val checkboxes = element.querySelectorAll("input[type=checkbox]")
        val selected = mutableListOf<String>()
        for (i in 0 until checkboxes.length) {
            val cb = checkboxes.item(i) as? HTMLInputElement ?: continue
            if (cb.checked) selected.add(cb.name)
        }
        window.localStorage.setItem(storageKey, selected.joinToString(","))
    }
}
